/**
 * dom 处理类
 * @class UtilDom
 * @example
 * import WSLib from '@tencent/weishi-lib';
 * WSLib.wsUtil.dom.str2dom('<h1>Hello World<h1>');
 */
export class UtilDom {
  /**
   * 转换字符串为 dom 结构
   * @param {String} str string
   * @returns {Null | HTMLElement}
   */
  str2dom(str) {
    if (!str) {
      return null;
    }
    const div = document.createElement('div');
    div.innerHTML = str;
    // return div.firstChild;
    return div.firstElementChild;
  }
}

export default new UtilDom();
